module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-tm-fill-c80a4b93.svg";